import React from 'react';
import PropTypes from 'prop-types';

import { Box, Combobox, Heading, Label } from '@zillow/constellation-10';

import RMWInput from '../../../RMWInput';

const propTypes = {
  convertableList: PropTypes.array.isRequired,
  handleOptionSelect: PropTypes.func.isRequired,
  selectedItem: PropTypes.object.isRequired,
};
const defaultProps = {};

const PropertyToConvert = ({ convertableList, handleOptionSelect, selectedItem }) => {
  const { floorplanName, unitName } = selectedItem;
  const intialDisplayValue = floorplanName && unitName ? `${floorplanName} (Unit: ${unitName})` : `${floorplanName}`;

  return (
    <div data-testid="PropertyToConvert">
      <Box css={{ marginBottom: '400' }}>
        <Heading level={4}>Floor plan/unit</Heading>
      </Box>
      <Box>
        <Label required={true}>Floor plan or unit to convert</Label>
        <Combobox
          value={intialDisplayValue}
          onOptionSelect={handleOptionSelect}
          options={convertableList}
          placeholder="Please choose a floor plan or unit"
        />
      </Box>

      <Box css={{ marginBlock: '400', display: 'flex', flexDirection: 'row', gap: '600' }}>
        <RMWInput disabled={true} initialValue={selectedItem.price} label="Price" placeholder="Price" />

        <RMWInput
          disabled={true}
          initialValue={selectedItem.squareFeet}
          label="Square footage"
          placeholder="Square footage"
        />
      </Box>

      <Box css={{ marginBlock: '400', display: 'flex', flexDirection: 'row', gap: '600' }}>
        <RMWInput disabled={true} initialValue={selectedItem.beds} label="Beds" placeholder="Beds" />

        <RMWInput disabled={true} initialValue={selectedItem.baths} label="Baths" placeholder="Baths" />
      </Box>
    </div>
  );
};

PropertyToConvert.defaultProps = defaultProps;
PropertyToConvert.propTypes = propTypes;

export default PropertyToConvert;
